import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { PorletHeaderTitle } from 'components/porletHeader';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Button from '@material-ui/core/Button';
import Dialog from '../dialog';

export const Sheets = ({ values }) => {
  const Sheets = get(values, 'data.applications', []) || [];
  const Seguridad = Sheets.filter((sheet) => sheet.film.type === 2);
  const Solar = Sheets.filter((sheet) => sheet.film.type === 1);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <div>
      {Boolean(Seguridad.length) && (
        <>
          <PorletHeaderTitle variant="h5">
            <FormattedMessage id="Seguridad" />
          </PorletHeaderTitle>
          <div className="kt-space-20" />
          {Seguridad.map((sheet, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-12 ViewOrEdit">
                  <div>
                    <strong>
                      <FormattedMessage id="Película de control solar:" />
                    </strong>
                    <span>{sheet.film.name}</span>
                  </div>
                  <div className="kt-space-20" />
                  <div>
                    <strong>
                      <FormattedMessage id="M2 Necesarios:" />
                    </strong>
                    <span>{sheet.meters}</span>
                  </div>
                  <div className="kt-space-20" />
                  <div>
                    <strong>
                      <FormattedMessage id="Distribuidor:" />
                    </strong>
                    <span>{sheet.distributor.name}</span>
                  </div>
                  <div className="kt-space-10" />
                  <div>
                    <div className="kt-space-20" />

                    <strong>
                      <div className="kt-space-10" />
                      <FormattedMessage id="Número de RUN:" />
                    </strong>
                    <span>
                      <div className="kt-space-10" />
                      {sheet.run}
                    </span>
                    <span className=" mt-0 ml-3">
                      <Button
                        variant="contained"
                        color="primary"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClick={handleOpenDialog}
                      >
                        <MailOutlineIcon />
                        <FormattedMessage id="Denunciar RUN" />
                      </Button>
                      {/* <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleOpenDialog}>
                          <MailOutlineIcon />
                          <FormattedMessage id="Denunciar RUN" />
                        </MenuItem> 
                      </Menu>*/}
                    </span>
                  </div>
                  {Seguridad.length - 1 !== index && (
                    <div className="kt-space-20" />
                  )}
                </div>
              </div>
            );
          })}
        </>
      )}
      {Boolean(Seguridad.length) && Boolean(Solar.length) && (
        <div className="kt-space-20" />
      )}
      {Boolean(Solar.length) && (
        <>
          <PorletHeaderTitle variant="h5">
            <FormattedMessage id="Control Solar" />
          </PorletHeaderTitle>
          <div className="kt-space-20" />
          {Solar.map((sheet, index) => {
            return (
              <div className="row" key={index}>
                <div className="col-12 ViewOrEdit">
                  <div>
                    <strong>
                      <FormattedMessage id="Lámina de seguridad:" />
                    </strong>
                    <span>{sheet.film.name}</span>
                  </div>
                  <div className="kt-space-20" />
                  <div>
                    <strong>
                      <FormattedMessage id="M2 Necesarios:" />
                    </strong>
                    <span>{sheet.meters}</span>
                  </div>
                  <div className="kt-space-20" />
                  <div>
                    <strong>
                      <FormattedMessage id="Distribuidor:" />
                    </strong>
                    <span>{sheet.distributor.name}</span>
                  </div>
                  <div className="kt-space-10" />
                  <div>
                    <strong>
                      <div className="kt-space-10" />
                      <FormattedMessage id="Número de RUN:" />
                    </strong>
                    <span>
                      <div className="kt-space-10" />
                      {sheet.run}
                    </span>
                    <span className=" mt-0 ml-3">
                      <Button
                        variant="contained"
                        color="primary"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClick={handleOpenDialog}
                      >
                        <MailOutlineIcon />
                        <FormattedMessage id="Denunciar RUN" />
                      </Button>
                    </span>
                  </div>
                  {Solar.length - 1 !== index && (
                    <div className="kt-space-20" />
                  )}
                </div>
              </div>
            );
          })}
        </>
      )}
      {openDialog && (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          close={handleClose}
          code={values.uuid}
        />
      )}
    </div>
  );
};

export default Sheets;
